import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { Routes, RouterModule } from '@angular/router';

import { IonicModule } from '@ionic/angular';

import { DienstplanPage } from './dienstplan.page';
import {StoreModule} from '@ngrx/store';
import {EffectsModule} from '@ngrx/effects';
import {DienstplanPageUiEffects} from './dienstplan.effects.ui';
import {reducers} from './dienstplan.reducer';
import {SopiComponentsModule} from '../../../shared/sopi-components/sopi-components.module';
import {VeranstaltungenDienstplanVeranstaltungDienstplan2Effects} from '../../../../client-ngrx/veranstaltungen-dienstplan';

const routes: Routes = [
  {
    path: '',
    component: DienstplanPage
  }
];

@NgModule({
    imports: [
        CommonModule,
        FormsModule,
        IonicModule,
        RouterModule.forChild(routes),
        StoreModule.forFeature('DienstplanPage', reducers),
        EffectsModule.forFeature([
            DienstplanPageUiEffects,
            VeranstaltungenDienstplanVeranstaltungDienstplan2Effects
        ]),
        SopiComponentsModule,

    ],
    exports: [
        DienstplanPage
    ],
    declarations: [DienstplanPage]
})
export class DienstplanPageModule {}
